import React, { useEffect, useState } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './styles/App.css';
import Sidebar from './components/Sidebar';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Counter from './components/Counter';
import Projects from './components/Projects';
import Skills from './components/Skills';
import Experience from './components/Experience';
import Education from './components/Education';
import Contact from './components/Contact';
import MagicCursor from './components/MagicCursor';

function App() {
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
      mirror: true,
    });
  }, []);

  const toggleTheme = () => {
    setDarkMode(!darkMode);
  };

  return (
    <div className={`portfolio-index ${darkMode ? 'dark-mode' : ''}`}>
      <MagicCursor />
      <div className="portfolio-container">
        <div className="portfolio-dflex">
          <Sidebar darkMode={darkMode} toggleTheme={toggleTheme} />
          <div className="portfolio-content">
            <Navigation />
            <div className="overflow-hidden">
              <Hero />
              <Counter />
              <Projects />
              <Skills />
              <Experience />
              <Education />
              <Contact />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
